import {
  BaseThemeType,
  BatteryIcon,
  InverterIcon,
  LoadingDots,
  PanelIcon,
  PiggyBankIcon,
  styled,
  Typography,
} from 'opensolar-ui'
import React from 'react'
import { CheckoutFinancingPricingParams, FinanceMarketplaceSystemDetails } from '../types'
import { formatCurrencyWithSymbol } from '../utils'

type PropTypes = {
  pricingParams: CheckoutFinancingPricingParams
  isLoading: boolean
  systemDetails: FinanceMarketplaceSystemDetails | null
}

const MainWrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  backgroundColor: '#FAFBFC',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: '10px',
  flex: 1,
}))

const Price = styled(Typography)(({ theme }: { theme: BaseThemeType }) => ({
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '46px',
  letterSpacing: '-0.4px',
}))

const DetailRow = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
}))

const LoadingWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  opacity: 0.8,
}))

const IconWrapper = styled('div')(({ theme }: { theme: BaseThemeType }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
}))

const DetailsText = styled(Typography)(({ theme }: { theme: BaseThemeType }) => ({
  color: theme.palette.grey[900],
}))

const StyledPiggyBank = styled(PiggyBankIcon)(({ theme }: { theme: BaseThemeType }) => ({
  color: theme.palette.green[800],
}))

const SavingsText = styled(Typography)(({ theme }: { theme: BaseThemeType }) => ({
  color: theme.palette.green[800],
  marginLeft: '-4px',
}))

const FinanceMarketplaceSystemSummary: React.FC<PropTypes> = (props) => {
  return (
    <MainWrapper>
      {props.isLoading ? (
        <LoadingWrapper>
          <LoadingDots />
        </LoadingWrapper>
      ) : (
        <>
          <Typography textVariant="h5SemiBold">{props.systemDetails?.system_title}</Typography>
          <Price textVariant="h3">
            {formatCurrencyWithSymbol(
              props.systemDetails?.system_price_payable ?? props.systemDetails?.system_price_including_tax,
              props.systemDetails?.currency_symbol
            )}
          </Price>
          {props.systemDetails?.module_description && (
            <DetailRow>
              <PanelIcon />
              <DetailsText textVariant="body2">{props.systemDetails?.module_description}</DetailsText>
            </DetailRow>
          )}
          {props.systemDetails?.inverter_description && (
            <DetailRow>
              <InverterIcon />
              <DetailsText textVariant="body2">{props.systemDetails?.inverter_description}</DetailsText>
            </DetailRow>
          )}
          {props.systemDetails?.battery_description && (
            <DetailRow>
              <IconWrapper>
                <BatteryIcon />
              </IconWrapper>
              <DetailsText textVariant="body2">{props.systemDetails?.battery_description}</DetailsText>
            </DetailRow>
          )}
          {/* temporarily hiding the savings text per Propensio's request */}
          {/* <DetailRow>
            <IconWrapper>
              <StyledPiggyBank />
            </IconWrapper>
            <SavingsText textVariant="body2">{props.systemDetails?.annual_savings}</SavingsText>
          </DetailRow> */}
        </>
      )}
    </MainWrapper>
  )
}
export default FinanceMarketplaceSystemSummary
